import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AuthenticationService} from 'app/services/authentication.service';
import {Baseservice} from 'app/services/baseservice';
import {environment} from 'environments/environment';
import {BehaviorSubject, Subject} from 'rxjs';
import {map} from 'rxjs/operators';


@Injectable()
export class MonthlyComplianceService extends Baseservice {

    constructor(http: HttpClient, authentication: AuthenticationService) {
        super('monthly-compliance', http, authentication);
    }

    getcarrierlist(carrierId, params) {
        return this.http.get(`${this.url}/getcarrierlistformonthly/${carrierId}/${params}`);
    }


    loadPermitForwards(body) {
        return this.http.post(`${this.url}/createpermitreturns`, body);
    }
    loadReturnsData(body) {
        return this.http.post(`${this.url}/load-returns-data`, body);
    }

    savePermitReturnForwards(body) {
        return this.http.post(`${this.url}/savepermitreturns`, body);
    }

    declareNilReturns(body) {
        return this.http.post(`${this.url}/declare-nil-return`, body);
    }

    getComplianceReturn(id) {
        return this.http.get(`${this.url}/get-compliance-return/${id}`);
    }

    updateComplianceReturn(body) {
        return this.http.post(`${this.url}/update-compliance-return`, body);
    }

    deleteComplianceReturn(id) {
        return this.http.get(`${this.url}/delete-compliance-trip/${id}`);
    }
    getAllPermitReturn(id) {
        return this.http.get(`${this.url}/get-permit-return/${id}`);
    }
}
